import { h, Component } from 'preact';
import { Text, withText } from 'preact-i18n';

import LineChartCompare from '../gui/lineChartCompare';
import { buildTrendSeries, TREND_MONTHS } from '../../lib/ammoStats';

// Distinct hues per caliber; a club rarely stocks more than a handful.
export const CALIBER_COLORS = [
    'var(--bs-primary)',
    'var(--bs-danger)',
    'var(--bs-success)',
    'var(--bs-orange)',
    'var(--bs-purple)',
    'var(--bs-teal)',
];

/**
 * Buying trend per caliber for the last 12 months. `rows` is stats.byMonthCaliber
 * from /api/ammosales/stats loaded with the trend window (see ammoSaleStore.loadTrend).
 * On phones a narrow, taller viewBox keeps the lines readable instead of letterboxing
 * a wide chart into a short band (same approach as the convention analysis chart).
 */
@withText({ internalLabel: 'ammoSale.trend-internal' })
class AmmoTrendChart extends Component {
    constructor(props) {
        super(props);
        this.state = { metric: 'units' };
    }

    setMetric = (metric) => {
        this.setState({ metric });
    }

    render() {
        const {
            rows = [], now, months = TREND_MONTHS, isMobile = false, internalLabel,
        } = this.props;
        const { metric } = this.state;
        const { xLabels, xTickLabels, series } = buildTrendSeries(rows, {
            metric, now, months, colors: CALIBER_COLORS, internalLabel: internalLabel || 'internal',
        });
        const hasData = series.some(s => s.points.some(p => p.y > 0));
        return (
            <div class='mb-4'>
                <div class='d-flex flex-wrap justify-content-between align-items-center gap-2 mb-2'>
                    <h6 class='mb-0'>
                        <i class='fa-duotone fa-chart-line me-2' />
                        <Text id='ammoSale.trend-title' fields={{ months }}>Buying trend last {months} months</Text>
                    </h6>
                    <div class='btn-group btn-group-sm' role='group'>
                        <button
                            type='button'
                            class={`btn ${metric === 'units' ? 'btn-primary' : 'btn-outline-primary'}`}
                            onClick={() => this.setMetric('units')}
                        >
                            <Text id='ammoSale.trend-units'>Units</Text>
                        </button>
                        <button
                            type='button'
                            class={`btn ${metric === 'rounds' ? 'btn-primary' : 'btn-outline-primary'}`}
                            onClick={() => this.setMetric('rounds')}
                        >
                            <Text id='ammoSale.trend-rounds'>Rounds</Text>
                        </button>
                    </div>
                </div>
                {hasData && series.some(s => s.dash) && (
                    <small class='d-block text-body-secondary mb-1'>
                        <Text id='ammoSale.trend-legend-help'>Solid line = sold, dashed line = internal use.</Text>
                    </small>
                )}
                {hasData ? (
                    <LineChartCompare
                        series={series}
                        xLabels={xLabels}
                        xTickLabels={xTickLabels}
                        xTickEvery={isMobile ? 2 : 1}
                        width={isMobile ? 380 : 720}
                        height={isMobile ? 300 : 260}
                        paddingLeft={40}
                        strokeWidth={3}
                        fontSize={11}
                        smooth
                        area
                    />
                ) : (
                    <div class='text-body-secondary text-center py-3'>
                        <Text id='ammoSale.trend-empty'>No ammo sales in the last 12 months.</Text>
                    </div>
                )}
            </div>
        );
    }
}

export default AmmoTrendChart;
